// lib
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { call, delay } from 'redux-saga/effects'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export default function* sendReportInvitationLinkSaga(payload) {
  const requestURL = staticStore.urls.sendEmailsSharedKey
  if (!requestURL) {
    throw new Error('No "sendEmailsSharedKey" endpoint URL')
  }

  for (let i = 0; i < 5; i++) {
    try {
      const response = yield call(railsPostFetch, requestURL, {
        body: JSON.stringify({
          dashboard_id: staticStore.dashboardID,
          ...payload
        })
      })
      if (!response.ok) {
        throw new Error(response.error || 'Error sending report invitation link')
      }
      const body = yield call([response, 'json'])
      return body
    } catch (error) {
      if (i < 4) {
        yield delay(1500)
      } else {
        throw error
      }
    }
  }

  throw new Error('Error sending report invitation link after multiple attempts')
}
